import type { BookmarkAssetRequest } from './assetPatchState';
import apiRequest from './apiRequest';

export default async function deleteAssetBookmark(
  apiKey: string,
  assetID: string,
  body: BookmarkAssetRequest,
) {
  return apiRequest<Record<string, never>>(
    'external-mogen',
    `/assets/bookmarks/${encodeURIComponent(assetID)}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(body),
    },
  );
}
